export default __webpack_public_path__ + "static/media/dolls.8d145566.png";